import { render, staticRenderFns } from "./HomeTwo.vue?vue&type=template&id=f967b116&scoped=true&"
import script from "./HomeTwo.vue?vue&type=script&lang=js&"
export * from "./HomeTwo.vue?vue&type=script&lang=js&"
import style0 from "./HomeTwo.vue?vue&type=style&index=0&id=f967b116&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f967b116",
  null
  
)

export default component.exports